// REACT
import * as React from 'react';


// CUSTOM COMPONENTS
import { StretchCard } from 'components';

// UTILS

const ProviderCard = (props) => {

        const { provider, lowestPrice } = props;
        return (
            <StretchCard
                key={provider.uid}
                cardImageHeight={225}
                linkURL={`/expert/${provider.uid}`}
                backgroundImageURL={provider.profilePhotoURL}
                typeTitleText={provider.expertise}
                mainTitleText={`${provider.name && provider.name.first} ${provider.name && provider.name.last}`}
                subTitleText={"Services starting at | "}
                subTitlePrice={`$${lowestPrice/100}`}
                cardTypeTitleColor={'#4AC4D1'}
                flexDirection={'column-reverse'}
                fontSizeDivider={1.3}
            />
        );
    }


export default ProviderCard;


// WEBPACK FOOTER //
// ./src/js/components/ProviderCardSection/ProviderCard.jsx